import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useModal from '../../customHooks/useModal';
import Button from '../../components/Button';
import Table from '../../components/Table';
import Modal from '../../components/Modal';
import Input from '../../components/Input';
import { FaTrash, FaPlus, FaSearch } from 'react-icons/fa';
import Paths from '../../constants/paths';
import { observer } from 'mobx-react-lite';
import Pagination from './../../components/Pagination';
import debounce from 'lodash.debounce';
import translations from '../../translations/de';

const Sectors = ({ store }) => {
    const history = useHistory();
    const modalRef = useRef(null);
    const [modal, setModal] = useModal(false, modalRef);
    const [sectorID, setSectorID] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        store.getSectors(searchQuery);
    }, [store, store.selectedPage, searchQuery]);

    const handleSector = (id) => {
        store.selectSector(id);
        history.push(`/sectors/${store.selectedSector.id}`);
    };
    const onSearchChangeHandler = debounce((e) => {
        store.setSelectedPage(1);
        setSearchQuery(e.target.value);
    }, 500);
    return (
        <>
            <div style={{ marginLeft: '2.5%' }}>
                <Input placeholder={translations.search} onChange={onSearchChangeHandler} />
                <Button
                    label={translations.sector}
                    onClick={() => {
                        store.selectSector(undefined);
                        history.push(Paths.NEW_SECTOR);
                    }}
                >
                    <FaPlus style={{ marginRight: '5px' }} />
                </Button>
            </div>
            <Table
                tablePagination={
                    store.totalPages > 1 && (
                        <Pagination
                            totalPages={store.totalPages}
                            selectedPage={store.selectedPage}
                            onSelectedPageChange={(selected) => store.setSelectedPage(selected)}
                        />
                    )
                }
                tableName={translations.sectors}
                columns={[
                    {
                        Header: 'Id',
                        accessor: 'id',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.title,
                        accessor: 'title',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: '',
                        accessor: 'action',
                        Cell: ({ row }) => (
                            <div>
                                <Button
                                    onClick={() => {
                                        handleSector(row.cells[0].value);
                                    }}
                                    title={translations.show}
                                >
                                    <FaSearch />
                                </Button>
                                <Button
                                    onClick={() => {
                                        setSectorID(row.cells[0].value);
                                        setModal(true);
                                    }}
                                    title={translations.delete}
                                >
                                    <FaTrash />
                                </Button>
                            </div>
                        ),
                    },
                ]}
                data={store.sectors.map(({ id, title }) => {
                    return {
                        id,
                        title,
                    };
                })}
            />
            {modal && (
                <Modal
                    title="Delete Sector"
                    ref={modalRef}
                    onClose={() => setModal(false)}
                    maxWidth="400px"
                >
                    <p style={{ color: '#333', marginBottom: '20px' }}>
                        Are you sure you want to delete this sector?
                    </p>
                    <div className="Modal-Controls">
                        <Button
                            label="Yes"
                            onClick={() => {
                                store.deleteSector(sectorID);
                                setModal(false);
                            }}
                            style={{ width: '80px' }}
                        />
                        <Button
                            label="No"
                            onClick={() => setModal(false)}
                            style={{ width: '80px', marginLeft: '20px' }}
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default observer(Sectors);
